import { Sorts, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { SegmentFilters } from "@domains/entities/interfaces/Reports/LedgerReport/ILedgerReportDetail";
import { ILedgerSnapShotExtentionTYPES } from "@domains/entities/interfaces/Reports/LedgerReport/ILedgerSnapShotExtention";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { pnlDownloadDate } from "@domains/utils/reportDates";
import { ESortOrder } from "@domains/utils/sort";
import moment from "moment";
export var LedgerTabsType;
(function (LedgerTabsType) {
    LedgerTabsType["SNAPSHOT"] = "snapshot";
    LedgerTabsType["DETAILED"] = "detailed";
})(LedgerTabsType || (LedgerTabsType = {}));
export var LedgerRender;
(function (LedgerRender) {
    LedgerRender["LEDGEREPORT"] = "LEDGEREPORT";
    LedgerRender["FUNDSDETAILS"] = "FUNDSDETAILS";
})(LedgerRender || (LedgerRender = {}));
export const LedgerCustomTimeRange = `The selected date range should be either before 1st September
2019 or After 1st September 2019. Due to technical issues, we
will not be able to provide report with data on both sides of
1st Sept 2019.`;
export const LedgerReportsFilters = [
    {
        filterName: "Voucher",
        eventKey: "Voucher",
        list: [
            { title: "Bills", key: "Bills", selected: false },
            { title: "Payment", key: "Payment", selected: false },
            { title: "Receipt", key: "Receipt", selected: false },
            { title: "OPBAL", key: "OPBAL", selected: false },
            { title: "JV", key: "JV", selected: false },
        ],
        selectType: "checkbox",
    },
    {
        filterName: "Exchange",
        eventKey: "Exchange",
        list: [
            { title: "NSF", key: "NSF", selected: false },
            { title: "BSE", key: "BSE", selected: false },
            { title: "NSEF", key: "NSEF", selected: false },
            { title: "NSEC", key: "NSEC", selected: false },
        ],
        selectType: "checkbox",
    },
];
export const FundsDropdown = [
    {
        title: "Funds Withdrawn By You",
        value: ILedgerSnapShotExtentionTYPES.PAYOUT,
    },
    {
        title: "Funds Received from You",
        value: ILedgerSnapShotExtentionTYPES.PAYIN,
    },
    { title: "Cash Segment", value: ILedgerSnapShotExtentionTYPES.CASH },
    {
        title: "Derivatives Segment",
        value: ILedgerSnapShotExtentionTYPES.DERIVATIVES,
    },
    {
        title: "MFSS Segment",
        value: ILedgerSnapShotExtentionTYPES.MFSS,
    },
];
export const SnapShotAssetPair = [
    {
        title: "Opening Balance",
        valFromAPI: "Opening Balance",
        rowClass: "bg_monochromeGrey",
        LshiftedRow: "DMSanBold_18_700 txt_blackOne1 bg_monochromeGrey",
        allowOnClick: false,
        RshiftedRow: "bg_monochromeGrey",
        LshiftedRowMob: "DMSan_14_700 txt_blackOne1 bg_monochromeGrey",
    },
    {
        title: "Funds In/Out",
        valFromAPI: "Inflow / Outflow",
        rowClass: "",
        LshiftedRow: "DMSan_16_700",
        allowOnClick: false,
        LshiftedRowMob: "DMSan_14_700",
    },
    {
        title: "Funds Received from you",
        valFromAPI: "Funds Received from You",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: true,
        shotExtention: ILedgerSnapShotExtentionTYPES.PAYIN,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "Funds Withdrawn by you",
        valFromAPI: "Funds Withdrawn by You",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: true,
        shotExtention: ILedgerSnapShotExtentionTYPES.PAYOUT,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "Funds Utilisation (-)",
        valFromAPI: "Funds Utilization (Segment wise breakup of transactions)",
        rowClass: "",
        LshiftedRow: "DMSan_16_700",
        allowOnClick: false,
        LshiftedRowMob: "DMSan_14_700",
    },
    {
        title: "Cash Segment",
        valFromAPI: "Cash Segment",
        rowClass: "",
        LshiftedRow: "pdl-33  DMSans_16_500",
        allowOnClick: true,
        shotExtention: ILedgerSnapShotExtentionTYPES.CASH,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "Derivatives Segment",
        valFromAPI: "Derivatives Segment",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: true,
        shotExtention: ILedgerSnapShotExtentionTYPES.DERIVATIVES,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "MFSS Segment",
        valFromAPI: "MFSS Segment",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: true,
        shotExtention: ILedgerSnapShotExtentionTYPES.MFSS,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "IPO / Bonds / NCDs",
        valFromAPI: "IPO / Bonds / NCDs",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: false,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "Miscellaneous",
        valFromAPI: "Miscellaneous",
        rowClass: "",
        LshiftedRow: "DMSan_16_700",
        allowOnClick: false,
        LshiftedRowMob: "DMSan_14_700",
    },
    {
        title: "Reversals, Charges and Others",
        valFromAPI: "Reversals, Charges and Others",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: false,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "Closing Balance",
        valFromAPI: "Closing Balance",
        rowClass: "bg_monochromeGrey",
        LshiftedRow: "DMSanBold_18_700 bg_monochromeGrey",
        allowOnClick: false,
        RshiftedRow: "bg_monochromeGrey",
        LshiftedRowMob: "DMSan_14_700 txt_blackOne1 bg_monochromeGrey",
    },
];
export const SnapShotAssetPairCommodity = [
    {
        title: "Opening Balance",
        valFromAPI: "Opening Balance",
        rowClass: "bg_monochromeGrey",
        LshiftedRow: "DMSanBold_18_700 bg_monochromeGrey",
        allowOnClick: false,
        RshiftedRow: "bg_monochromeGrey",
        LshiftedRowMob: "DMSan_14_700 txt_blackOne1 bg_monochromeGrey",
    },
    {
        title: "Funds In/Out",
        valFromAPI: "Inflow / Outflow",
        rowClass: "",
        LshiftedRow: "DMSan_16_700",
        allowOnClick: false,
        LshiftedRowMob: "DMSan_14_700",
    },
    {
        title: "Funds Received from you",
        valFromAPI: "Funds Received from You",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: false,
        shotExtention: ILedgerSnapShotExtentionTYPES.PAYIN,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "Funds Withdrawn by you",
        valFromAPI: "Funds Withdrawn by You",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: false,
        shotExtention: ILedgerSnapShotExtentionTYPES.PAYOUT,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "Funds Utilisation (-)",
        valFromAPI: "<b>Funds Utilization</b></br>(Exchange wise breakup of transactions)",
        rowClass: "",
        LshiftedRow: "DMSan_16_700",
        allowOnClick: false,
        LshiftedRowMob: "DMSan_14_700",
    },
    {
        title: "Commodity Segment",
        valFromAPI: "Commodity Segment",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: false,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "Miscellaneous",
        valFromAPI: "Miscellaneous",
        rowClass: "",
        LshiftedRow: "DMSan_16_700",
        allowOnClick: false,
        LshiftedRowMob: "DMSan_14_700",
    },
    {
        title: "Reversals, Charges and Others",
        valFromAPI: "Reversals, Charges and Others",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: false,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "Closing Balance",
        valFromAPI: "Closing Balance",
        rowClass: "bg_monochromeGrey",
        LshiftedRow: "DMSanBold_18_700 bg_monochromeGrey",
        allowOnClick: false,
        RshiftedRow: "bg_monochromeGrey",
        LshiftedRowMob: "DMSan_14_700 txt_blackOne1 bg_monochromeGrey",
    },
];
export const SnapShotAssetPairMTF = [
    {
        title: "Opening Balance",
        valFromAPI: "Opening Balance",
        rowClass: "bg_monochromeGrey ",
        LshiftedRow: "DMSanBold_18_700 bg_monochromeGrey",
        allowOnClick: false,
        RshiftedRow: "bg_monochromeGrey",
        LshiftedRowMob: "DMSan_14_700 txt_blackOne1 bg_monochromeGrey",
    },
    {
        title: "Funds Utilisation (-)",
        valFromAPI: "Funds Utilization (Segment wise breakup of transactions)",
        rowClass: "",
        LshiftedRow: "DMSan_16_700",
        allowOnClick: false,
        LshiftedRowMob: "DMSan_14_700",
    },
    {
        title: "Cash Segment",
        valFromAPI: "Cash Segment",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: true,
        shotExtention: ILedgerSnapShotExtentionTYPES.CASH,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "Miscellaneous",
        valFromAPI: "Miscellaneous",
        rowClass: "",
        LshiftedRow: "DMSan_16_700",
        allowOnClick: false,
        LshiftedRowMob: "DMSan_14_700",
    },
    {
        title: "Reversals, Charges and Others",
        valFromAPI: "Reversals, Charges and Others",
        rowClass: "",
        LshiftedRow: "pdl-33 DMSans_16_500",
        allowOnClick: false,
        LshiftedRowMob: "ps-4 DMSanM_14_500",
    },
    {
        title: "Closing Balance",
        valFromAPI: "Closing Balance",
        rowClass: "bg_monochromeGrey ",
        LshiftedRow: "DMSanBold_18_700 bg_monochromeGrey",
        allowOnClick: false,
        RshiftedRow: "bg_monochromeGrey",
        LshiftedRowMob: "DMSan_14_700 txt_blackOne1 bg_monochromeGrey",
    },
];
export const LEDGER_FILTER_SEGMENT = [
    { title: "All Segments", value: SegmentFilters.ALL },
    { title: "Cash Segment", value: SegmentFilters.CASH },
    { title: "F&O Segment", value: SegmentFilters.DERIVATIVE },
    { title: "Currency Segment", value: SegmentFilters.CURRENCY },
    { title: "Funds Brought In", value: SegmentFilters.PAYIN },
    { title: "Funds Moved Out", value: SegmentFilters.PAYOUT },
];
export const sortlistLedger = [
    new Sorts([
        {
            title: "Date",
            key: "date",
            order: ESortOrder.UNCHANGED,
            orderText: { desc: "Highest to Lowest", asc: "Lowest to Highest" },
            type: "Date",
        },
        {
            title: "Voucher Type",
            key: "voucherType",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
            type: "string",
        },
        {
            title: "Exchange",
            key: "exchange",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
            type: "string",
        },
        {
            title: "Settlement No",
            key: "settlement",
            order: ESortOrder.UNCHANGED,
            orderText: { desc: "Highest to Lowest", asc: "Lowest to Highest" },
            type: "string",
        },
        {
            title: "Narration",
            key: "narration",
            order: ESortOrder.UNCHANGED,
            orderText: { asc: "Z to A", desc: "A to Z" },
            type: "string",
        },
        {
            title: "Cheque No",
            key: "cheque",
            order: ESortOrder.UNCHANGED,
            orderText: { desc: "Highest to Lowest", asc: "Lowest to Highest" },
            type: "number",
        },
        {
            title: "Receipts",
            key: "receiptsInRs",
            order: ESortOrder.UNCHANGED,
            orderText: { desc: "Highest to Lowest", asc: "Lowest to Highest" },
            type: "numberWithComma",
        },
        {
            title: "Payments",
            key: "paymentsInRs",
            order: ESortOrder.UNCHANGED,
            orderText: { desc: "Highest to Lowest", asc: "Lowest to Highest" },
            type: "numberWithComma",
        },
        {
            title: "Cum Balance",
            key: "cummulativeBalance",
            order: ESortOrder.UNCHANGED,
            orderText: { desc: "Highest to Lowest", asc: "Lowest to Highest" },
            type: "numberWithComma",
        },
    ]),
];
export const downloadRestrictionForComm = (accType, COMEQTOGGLE) => {
    if ((accType === ILoginAccountTypes.COMEQ &&
        COMEQTOGGLE === ILoginAccountTypes.CO) ||
        accType === ILoginAccountTypes.CO)
        return moment("1 sep 2019").toDate();
    return pnlDownloadDate;
};
export const DateRangeExceedsOneYear = "Date range selection cannot exceed one financial year";
